import { FadeUp } from "@/components/motion";

const PITCH_QUESTIONS = [
  "Who needs what you can offer?",
  "What problems can you help solve?",
  "What results and impact have you delivered?",
  "What makes your approach valuable?",
  "What evidence supports your claims?",
];

export default function Positioning() {
  return (
    <section data-testid="positioning" id="positioning" className="relative bg-[#0A0A0A] py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp className="mb-14 md:mb-20 max-w-3xl">
          <p className="tracking-label text-[11px] uppercase font-body font-bold text-[#DFFF00] mb-6">Your professional pitch</p>
          <h2 className="font-display font-bold tracking-tighter leading-[0.95] text-4xl md:text-6xl text-[#F8F8F5]">
            Think of your career as your <span className="font-serif-accent font-light">professional offering.</span>
          </h2>
          <p data-testid="pitch-intro" className="mt-8 font-body text-[18px] md:text-[20px] text-[#D4D4D8] leading-[1.6]">
            What can you help people achieve? We help you bring your skills, experience and results
            together into a clear pitch, then build your CV and LinkedIn profile around it.
          </p>
        </FadeUp>

        <FadeUp delay={0.05}>
          <div data-testid="pitch-questions" className="border border-[#27272A] p-8 md:p-12">
            <p className="font-body text-[18px] text-[#A1A1AA] leading-[1.6] mb-8">
              Your pitch starts with five simple questions:
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {PITCH_QUESTIONS.map((q, i) => (
                <div key={q} className="border border-[#27272A] bg-[#141414] p-5 flex flex-col gap-3">
                  <span className="font-display text-2xl font-bold text-[#DFFF00] leading-none">{i + 1}</span>
                  <p className="font-body text-[18px] text-[#F8F8F5] leading-[1.5]">{q}</p>
                </div>
              ))}
            </div>
            <p className="mt-8 font-body text-[18px] text-[#D4D4D8] leading-[1.6] max-w-3xl">
              Your answers guide your career direction, your CV, your LinkedIn profile and your
              interview preparation. They can also help you explore consulting or self employment.
              You do not need a business idea to use the career service.
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
